import React, { useState, useEffect } from 'react';
import { Navigate } from 'react-router-dom';
import SessionExpiredPopup from '../components/SessionExpiredPopup/SessionExpiredPopup';

const ProtectedRoute = ({ children }) => {
  const token = localStorage.getItem('token') || sessionStorage.getItem('token');
  const devMode = localStorage.getItem('devMode') === 'enabled';
  const [sessionExpired, setSessionExpired] = useState(false);

  useEffect(() => {
    if (!token) return;

    try {
      const tokenParts = token.split('.');
      if (tokenParts.length !== 3) {
        if (!devMode) setSessionExpired(true);
        return;
      }

      const payload = JSON.parse(atob(tokenParts[1]));
      if (payload.exp * 1000 < Date.now()) {
        if (!devMode) setSessionExpired(true);
      }
    } catch (error) {
      if (!devMode) setSessionExpired(true);
    }
  }, [token, devMode]);

  const handleRelogin = () => {
    localStorage.removeItem('token');
    sessionStorage.removeItem('token');
    localStorage.removeItem('user');
    sessionStorage.removeItem('user');
    window.location.replace('/');
  };

  if (sessionExpired) {
    return (
      <>
        <SessionExpiredPopup
          isVisible={true}
          onClose={() => setSessionExpired(false)}
          onRelogin={handleRelogin}
        />
      </>
    );
  }

  // If there’s no token at all
  if (!token && !devMode) {
    return <Navigate to="/" replace />;
  }

  // Dev mode override — skip token validation
  if (devMode) {
    return children;
  }

  return children;
};

export default ProtectedRoute;
